import {
  MODAL_HIDDEN,
  MODAL_INTERACTION,
  MODAL_DATA_LOADED,
} from '../actions/constants';
import ModalFrom from '../components/modals/ModalFrom';
import TableRef from '../util/TableRef';
import { FROM } from '../util/enums/EnumLayers';

const INITIAL_STATE = {
  tables: [],
  selected: null,
  readyForSave: false,
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'selected':
      return { ...state, selected: payload.table, readyForSave: true };
    case 'reset':
      return { ...state, selected: null, readyForSave: false };
    default:
      return state;
  }
}

const modalFrom = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalFrom) {
        const { existing } = action.payload.props;
        const existingT = new TableRef(existing.schema(), existing.table());
        const tables = action.payload.props.allTables;
        const selected = tables.find((t) => t.equals(existingT));
        return { ...state, tables, selected };
      }
      return state;
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== FROM) {
        return state;
      }
      return interaction(state, action.payload.props);
    }
    default:
      return state;
  }
};

export default modalFrom;
